module.exports = __webpack_public_path__ + "static/img/logo.a7e440ac.png";